import React, {useContext, useEffect, useState} from 'react'
import ListItem from "../common/ListItem";
import ListGroup from "../common/ListGroup";
import axios from "../common/axios";
import CircularLoader from "../common/CircularLoader";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import {NavigationContext} from "../common/NavigationContext";

const CompetitionsNavigation = ({ notificationDescription, unreadMessagesCount }) => {
    const [studentCompetitions, setStudentCompetitions] = useState();
    const [isLoading, setLoading] = useState(true);
    const { loadShortcutByUrl } = useCurrentShortcut();
    const { setNavVisible } = useContext(NavigationContext);

    const loadStudentCompetitions = () => {
        axios.get('/web/ui/competition/studentOpenCompetitions')
            .then(response => {
                setStudentCompetitions(response.data);
                setLoading(false);
            });
    }

    useEffect(() => {
        loadStudentCompetitions();
    }, []);

    const handleClick = () => {
        const shortcutUrl = '/web/ui/view/studentCompetitions';
        loadShortcutByUrl(shortcutUrl);
        setNavVisible(false);

        if (globalReactFunctions && globalReactFunctions.handleTitleNavMenuClose) {
            globalReactFunctions.handleTitleNavMenuClose();
        }
    }

    if(isLoading) {
        return <CircularLoader pageCentered={false}/>
    }

    if (studentCompetitions === undefined) {
        return null;
    }

    return(
        <ListGroup id={'competitions-notifications-control'} isDisclosureItem={true} title={notificationDescription} itemCount={studentCompetitions?.length} disabled={false} startOpen={true}>
            {studentCompetitions?.map(competition => {
                return(
                        <ListItem isDisclosureItem={true} className={'ch-link'} key={competition.competitionId} onClick={() => handleClick()}>
                            {competition.competitionName ? competition.competitionName : competition.conceptName}
                        </ListItem>
                    )
            })}
        </ListGroup>
    )
}

export default CompetitionsNavigation;